import { MessageService } from 'primeng/api';
import {Component, OnInit, EventEmitter, Output, OnDestroy} from '@angular/core';
import {Subject, Subscription, takeUntil} from 'rxjs';
import { NavigationExtras, Router, ActivatedRoute } from '@angular/router';
import { AuthentificationService } from 'src/app/services/auth/authentification.service';
import { LoginErrorsModel } from 'src/app/models/LoginErrors/LoginErrors';
import { UserNotFound } from 'src/app/models/LoginErrors/UserNotFound';
import { BaseLoginError } from 'src/app/models/LoginErrors/BaseLoginError';
import { UserLocked } from 'src/app/models/LoginErrors/UserLocked';
import { UserInactive } from 'src/app/models/LoginErrors/UserInactive';
import { TranslateService } from '@ngx-translate/core';
import { UserDesactivated } from 'src/app/models/LoginErrors/userDesactivated';
import { PopupsInfo } from '../../tools/page-login-popups/models/popups-info.model';
import { pageLoginService } from 'src/app/services/page-login/page-login.service';
import { PopupType } from '../../tools/page-login-popups/models/popupType.model';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { TrustbuilderDispatcher } from 'src/app/dispatchers/Trustbuilder-dispatcher';
import { footerService } from 'src/app/services/footer.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import {ConfigurationService} from "../../../services/configuration.service";
import {EnvironmentService} from "../../../services/environment.service";

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    providers: [MessageService]
})

export class LoginComponent extends TrustbuilderDispatcher implements OnInit,OnDestroy {
    errorToken: boolean;
	display_dialog_info :boolean=false;
    submitted: boolean;
    copyrightHtml: string = "";
    dialogInfoHtml: string = "";
    loginInfoHtml: string = "";
    pageLogin : any
    imageSrc: string;
    isVisible : boolean = false;

    popupsInfo: PopupsInfo;
    popupsFirstConnection: PopupsInfo;
    popupType = PopupType.LOGIN_With_FIRST_CONNECTION
    isManager = this.environmentService.get().managerType;
    appVersion: string;
    currentYear: number = new Date().getFullYear();
    safeHtml: SafeHtml;
    @Output() closed: EventEmitter<boolean> = new EventEmitter<boolean>();
    hidePremConxProcess =  this.configurationService.get().hidePremConxProcess;

    private destroy$ = new Subject<void>();


    constructor(public authentificationService: AuthentificationService, private router : Router, readonly translate : TranslateService, private sanitizer: DomSanitizer,
        private activatedRoute:ActivatedRoute, private messageService:MessageService,
        private pageLoginService: pageLoginService, private cookieService: CookieService, private footerService: footerService, private configurationService: ConfigurationService,private environmentService: EnvironmentService) {
        super(translate, authentificationService);
        this.trustBuilderAuthEvent.subscribe(() => this.authenticate());
        const navigation = this.router.getCurrentNavigation();
        const state = navigation.extras.state as {identifiant: string};
        this.credentials.username = state?.identifiant;
        state?.identifiant ? setTimeout(() => {
            this.messageService.add({key: 'SUCCESS_ACTIVATION_ACCOUNT',severity:'success', summary: 'Activation réussie', detail: 'Votre compte est maintenant activé'});
        }, 50) : null;
        const errorState = navigation.extras.state as {errorToken: boolean};
        errorState?.errorToken==true ? setTimeout(() => {
            this.messageService.add({key: 'ERROR_TOKEN',severity:'error', summary: 'Une erreur est survenue', detail: 'Veuillez réessayer'});
        }, 50) : null;
    }

    loginErrors: any;
    loading = false;
    display_premiere_connexion : boolean = false;



    ngOnInit() {
        // this.credentials.username = '013374400';
        // this.credentials.password = 'Abc1234567+';
        this.messageService.add({ key: 'tokenError', severity: 'error', summary: 'Error', detail: 'Token invalide' })
        // this.credentials.username = '013374400';
        // this.credentials.password = 'Abc1234567+';
        this.loadWordingCopyright();
        this.loadWordingDialogPremiereConnexion();
        this.loadWordingLoginInfo();
        this.loadAppVersion();
        // Vérification des paramètres de l'URL
        this.activatedRoute.queryParams.subscribe(params => {
            const status = params['Status'];
            if (status === 'SIGNED') {
                this.messageService.add({
                    key: 'adhesion',
                    severity: 'success',
                    summary: this.translate.instant('login.succes-adhesion-summary'),
                    detail: this.translate.instant('login.succes-adhesion-detail')
                });
            }
        });
        this.clearLoginError
          .pipe(takeUntil(this.destroy$))
          .subscribe(clear => {
            if(clear){
              this.resetLoginErrors();
              this.credentials.password = '';
            }
          });
      }

  ngOnDestroy(): void {
    this.destroy$?.next();
    this.destroy$?.complete();
  }


      loadWordingCopyright() {
        this.translate.get('login.copyright').subscribe((value: string) => {
            this.copyrightHtml = value;
        });
    }

    loadWordingDialogPremiereConnexion() {
        this.translate.get('login.dialogInfo_text').subscribe((value: string) => {
            this.dialogInfoHtml = value;
        });
    }

    loadWordingLoginInfo() {
        this.translate.get('login.info').subscribe((value: string) => {
            this.loginInfoHtml = value;
        });
    }


    authenticate() {
        this.submitted=true
        this.resetLoginErrors();
        if ((this.credentials.password || this.mfaLoginAsk || this.mfaDeviceLoginAsk || this.mfaRegisterAsk) && this.credentials.username) {
            this.submitted=false
            this.loading = true;
            var authentificateSubscription = this.authentificationService.authenticate(this.credentials).subscribe({
                next: (data) => {
                    if (data instanceof BaseLoginError) {
                        this.loginErrors = data;
                    } else {
                        if (data.validation != null) {
                            this.processMfaValidation(data);
                        } else {
                             this.authentificationService.processSuccessfulAuthentication(data);
                        }
                    }
                    this.unsubscribe(authentificateSubscription);
                    this.loading = false;
                    this.mfaSpinner = false;
                }
            });
        } else {
            this.submitted=true
        }
    }

    unsubscribe(subscription: Subscription) {
        subscription.unsubscribe();
    }
    showInfo(): boolean {
        return this.display_dialog_info = true;
    }
    premiereConnexion() {
            this.pageLoginService.getPageLoginPopups(PopupType.FIRST_CONNECTION).subscribe({
                next: (data) => {
                    this.getPopupFirstConnection(data);
                    this.display_premiere_connexion = true;
                },
                error: () => {
                    this.display_premiere_connexion = true;
                }
            });

    }
    navigateToPremiereConnexion(identifiant: boolean) {
        const navigationExtras: NavigationExtras = { state: { identifiant: identifiant }};
        this.router.navigate(['/auth/premiere_connexion'], navigationExtras);
    }

    resetLoginErrors() {
        this.submitted=false;
        this.loginErrors = new LoginErrorsModel();

    }


    isUserLocked() {
        return this.loginErrors instanceof UserLocked && this.loginErrors.isShow;
    }

    isUserInactive() {
        return this.loginErrors instanceof UserInactive && this.loginErrors.isShow;
    }

    isUserNotFound() {
        return this.loginErrors instanceof UserNotFound && this.loginErrors.isShow;
    }

    isUserDesactivated() {
        return this.loginErrors instanceof UserDesactivated && this.loginErrors.isShow;
    }

    dialogInfoClose(e){
        this.display_dialog_info=!e;
    }
    getPopupInfo(popupInfo) {
        this.popupsInfo = popupInfo
    }
    getPopupFirstConnection(popupFirstConnection) {
        this.popupsFirstConnection = popupFirstConnection
        this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this.popupsFirstConnection?.content);
    }


    loadAppVersion() {
    this.footerService.getAppVersion().subscribe(
      version => {
        this.appVersion = 'V ' + version;
      },
    );
    }
      closeDialog(){
    this.closed.emit(true);
  }

}
